import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, Building, MapPin, Phone, Mail, Calendar, Users, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";

const MentionsLegales = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center space-x-4">
            <Button 
              variant="outline" 
              onClick={() => navigate('/')}
              className="flex items-center space-x-2"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Retour à l'accueil</span>
            </Button>
            <h1 className="text-3xl font-bold text-gray-900">Mentions Légales</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto space-y-8">
          
          {/* Informations sur l'entreprise */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center space-x-2">
                <Building className="h-5 w-5 text-orange-500" />
                <span>Informations sur l'entreprise</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Raison sociale</h3>
                  <p className="text-gray-700">OUTILMATPRO</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Forme juridique</h3>
                  <p className="text-gray-700">SAS (Société par Actions Simplifiée)</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Capital social</h3>
                  <p className="text-gray-700">5 000 €</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Date de création</h3>
                  <p className="text-gray-700">24 septembre 2013</p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Identifiants légaux */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center space-x-2">
                <FileText className="h-5 w-5 text-orange-500" />
                <span>Identifiants légaux</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">SIREN</h3>
                  <p className="text-gray-700 font-mono">797 802 279</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">SIRET</h3>
                  <p className="text-gray-700 font-mono">797 802 279 00019</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Code NAF/APE</h3>
                  <p className="text-gray-700">4669B - Commerce de gros de fournitures et équipements industriels divers</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">N° TVA Intracommunautaire</h3>
                  <p className="text-gray-700">FR40797802279</p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Adresse et contact */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center space-x-2">
                <MapPin className="h-5 w-5 text-orange-500" />
                <span>Adresse et contact</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Siège social</h3>
                  <div className="text-gray-700">
                    <p>7 Rue du Général de Monsabert</p>
                    <p>34500 Béziers</p>
                    <p>France</p>
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Téléphone</h3>
                    <p className="text-gray-700">+33 6 61 01 84 89</p>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Email</h3>
                    <p className="text-gray-700">contact@outilmatpro.fr</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Informations sur le site web */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center space-x-2">
                <Users className="h-5 w-5 text-orange-500" />
                <span>Informations sur le site web</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Éditeur du site</h3>
                <p className="text-gray-700">OUTILMATPRO</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Directeur de la publication</h3>
                <p className="text-gray-700">Le représentant légal de la société OUTILMATPRO</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Hébergement</h3>
                <p className="text-gray-700">
                  Ce site est hébergé par Skywork AI<br/>
                  Service d'hébergement web professionnel
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Propriété intellectuelle */}
          <Card>
            <CardHeader>
              <CardTitle>Propriété intellectuelle</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="prose prose-gray max-w-none">
                <p>
                  L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. 
                  Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                </p>
                <p>
                  La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite 
                  sauf autorisation expresse du directeur de la publication.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Protection des données */}
          <Card>
            <CardHeader>
              <CardTitle>Protection des données personnelles</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="prose prose-gray max-w-none">
                <p>
                  Conformément à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), 
                  vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
                </p>
                <p>
                  Pour exercer ces droits, vous pouvez nous contacter à l'adresse : contact@outilmatpro.fr
                </p>
                <p>
                  Les données collectées sur ce site sont destinées uniquement à l'usage de OUTILMATPRO et ne sont en aucun cas cédées à des tiers.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Cookies */}
          <Card>
            <CardHeader>
              <CardTitle>Cookies</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="prose prose-gray max-w-none">
                <p>
                  Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. 
                  En continuant à naviguer sur ce site, vous acceptez l'utilisation de cookies.
                </p>
                <p>
                  Vous pouvez configurer votre navigateur pour refuser les cookies, mais certaines fonctionnalités du site pourraient ne plus être disponibles.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Responsabilité */}
          <Card>
            <CardHeader>
              <CardTitle>Limitation de responsabilité</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="prose prose-gray max-w-none">
                <p>
                  OUTILMATPRO s'efforce de fournir sur le site des informations aussi précises que possible. 
                  Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, 
                  qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
                </p>
                <p>
                  Tous les informations indiquées sur le site sont données à titre indicatif, et sont susceptibles d'évoluer. 
                  Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Date de mise à jour */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center space-x-2">
                <Calendar className="h-5 w-5 text-orange-500" />
                <span>Dernière mise à jour</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">Ces mentions légales ont été mises à jour le {new Date().toLocaleDateString('fr-FR')}.</p>
            </CardContent>
          </Card>

        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;